exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty-cell[data-v-08422684] {\n  text-align: center;\n  color: #505050;\n  padding-top: 5vmin;\n  padding-bottom: 5vmin;\n}\n\n", ""]);

// exports
